import states from '../../../../States';

export default {
	firstName: {
		label: 'First Name',
		required: true
	},
	middleInitial: {
		label: 'Middle Initial',
		//required: true
	},
	lastName: {
		label: 'Last Name',
		required: true
	},
	suffix: {
		label: 'Suffix',
		options: ['JR', 'SR', 'I', 'II', 'III', 'IV', 'DDS', 'MD', 'PHD'],
		useItem: true,
		validate: (fields) => true,
	},
	dateOfBirth: {
		label: 'Date of Birth',
		required: true,
		type: 'date'
	},
	gender: {
		label: 'Gender',
		options: ['Male', 'Female'],
		base: 1,
		required: true
	},
	maritalStatus: {
		label: 'Marital Status',
		base: 1,
		options: ['Single', 'Married', 'Divorced', 'Widowed'],
		required: true
	},
	driversLicenseNumber: {
		label: "Driver's License Number",
		required: true,
	},
	stateLicensed: {
		label: 'State Licensed',
		options: () => states.map((s) => s.name.toUpperCase()),
		base: () => 1,
		required: true
	},
	licenseStatus: {
		label: 'License Status',
		base: 1,
		options: ['N/A', 'Valid', 'Suspended', 'Revoked', 'Expired', 'Not Licensed'],
		required: true
	},
	relationship: {
		label: 'Relationship to Policyholder',
		options: ['Brother/Sister of Policyholder', 'Child of Policyholder', 'Parent/Guardian of Policyholder', 'Other Relation to Policyholder', ' Not Related to Policyholder', 'Spouse'],
		required: true
	},
	licensedForThreeOrMoreYears: {
		label: 'Number of Years Licensed',
		options: ['Less than 3', 'More than 3'],
		required: true
	},
	studentStatus: {
		label: 'Student Status',
		options: ['In state or at home, with a vehicle', 'Out of state, with a vehicle', 'Within 100 miles of home, without a vehicle', '100 miles or more from home, without a vehicle'],
		validate: (data) => (data.isBLevelStudent ? data.studentStatus !== null : true),
		required: true
	},
	isBLevelStudent: {
		label: 'Good Student',
		required: true
	},
	isDriversLicenseValid: {
		label: "Is Driver's License Valid?",
		required: true
	},
};
